import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 21h12V7H6v14zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z"
}), 'DeleteOutlineSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DeleteOutlineSharp.js
// module id = 3077
// module chunks = 2